/**
 * 【券包路由配置文件】
 * @desc 路由示例
 *  - http://localhost:8080/zh-CN/couponPack/food?nativeWebUIType=1
 *  - http://localhost:8080/zh-CN/couponPack/grocery?nativeWebUIType=1
 *  - http://localhost:8080/zh-CN/couponPack/rule
 */
import { pageTypeMap } from '@/page/couponPack/common/enums'

export default {
  path: '/couponPack',
  name: 'couponPack',
  meta: {
    requiresAuth: true,
  },
  component: () => import(/* webpackChunkName: "couponPackRoute" */ '@/page/couponPack/index.vue'),
  children: [
    {
      path: 'food',
      name: 'couponPackFood',
      meta: {
        pageType: pageTypeMap.food,
      },
      component: () =>
        import(/* webpackChunkName: "couponPackRoute" */ '@/page/couponPack/pages/main-entry.vue'),
    },
    {
      path: 'grocery',
      name: 'couponPackGrocery',
      meta: {
        pageType: pageTypeMap.grocery,
      },
      component: () =>
        import(/* webpackChunkName: "couponPackRoute" */ '@/page/couponPack/pages/main-entry.vue'),
    },
    {
      path: 'rule',
      name: 'couponPackRule',
      component: () =>
        import(/* webpackChunkName: "couponPackRoute" */ '@/page/couponPack/pages/coupon-rule.vue'),
    },
  ],
}
